import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import notificationSagas from './Notifications';

export default function* rootSaga(getState) {
	yield all([authSagas(), notificationSagas()]);
}



// WEBPACK FOOTER //
// ./sagas/index.js